import { render, staticRenderFns } from "./MelangeIcon.vue?vue&type=template&id=1a3208cb"
import script from "./MelangeIcon.vue?vue&type=script&lang=js"
export * from "./MelangeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports